// Full-screen status surface — used while the WASM sim loads or after a fatal error.

import { cn } from '@aod/ui/lib/utils';
import { AlertTriangle, Loader2 } from 'lucide-react';

interface SplashProps {
  readonly text: string;
  readonly error?: boolean;
}

export function Splash({ text, error }: SplashProps) {
  const Icon = error ? AlertTriangle : Loader2;
  return (
    <div className="fixed inset-0 grid place-items-center bg-background p-6 text-center">
      <div className="flex flex-col items-center gap-3 font-mono text-sm">
        <Icon
          className={cn(
            'size-7',
            error ? 'text-destructive' : 'animate-spin text-muted-foreground',
          )}
          aria-hidden
        />
        <span className={error ? 'text-destructive' : 'text-muted-foreground'}>{text}</span>
      </div>
    </div>
  );
}
